import { Outlet } from "react-router-dom"
const MainOthersProgress = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}

export default MainOthersProgress;